import { Injectable } from '@angular/core';
import { ExamdojoSupabaseService } from '@examdojo/supabase';
import { from } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClassStudentStatsHttpService {
  constructor(private readonly supabase: ExamdojoSupabaseService) {}

  fetchByClassId(classId: string) {
    return from(
      this.supabase.client
        .schema('classroom')
        .rpc('get_class_students_with_stats', { p_class_id: classId }, { get: true })
        .throwOnError()
        .then((response) => response.data!),
    );
  }
}
